import { render, staticRenderFns } from "./AppAlert.vue?vue&type=template&id=02e3491f&scoped=true"
import script from "./AppAlert.vue?vue&type=script&lang=js"
export * from "./AppAlert.vue?vue&type=script&lang=js"
import style0 from "./AppAlert.vue?vue&type=style&index=0&id=02e3491f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e3491f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
